module.exports = __webpack_public_path__ + "static/media/webcam.d8c0c525.svg";